import * as z from 'zod'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const ARIA_WORKFLOW_MESSAGE_TABLE = '"public"."aria_workflow_messages"'

const jsonbNullable = z.any().nullable()

export const AriaWorkflowMessageSchema = z.object({
  id: z.string(),
  workflow_state_id: z.string(),
  user_id: z.string().nullable(),
  status: z.string(),
  subject: z.string(),
  body: jsonbNullable,
  metadata: jsonbNullable,
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
})

export type AriaWorkflowMessageModel = z.infer<typeof AriaWorkflowMessageSchema>

export const AriaWorkflowMessageConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: ARIA_WORKFLOW_MESSAGE_TABLE,
  partitionKey: 'user_id',
  key: 'id',
  apiEndpoint: '/api/users/clerk/[user_id]/aria-workflow-messages',
  where: {},
  schema: AriaWorkflowMessageSchema,
}
